module.exports = __webpack_public_path__ + "img/FPX.11f6c259.png";